<template>
  <div>
    <transition name="fade">
      <BaseCard class="mt-4">
        <template v-slot:header>
          <div
            class="w-100 d-flex flex-row flex-wrap justify-content-between align-items-center"
          >
            <h3>لیست کسب و کارها</h3>
            <v-spacer></v-spacer>
            <span style="font-weight: 600">توجه</span>
            <span style="font-weight: 300; font-size: small"
              >لیست کسب و کارهایی که شما به آنها دسترسی دارید در این بخش قابل
              مدیریت است.</span
            >
            <!-- <a
              v-if="$store.getters.currentUserIsVisitor"
              :href="registerMerchantUrl"
              >ایجاد کسب و کار جدید</a
            > -->
          </div>
          <MerchantsSearch @searchParams="search"></MerchantsSearch>
        </template>
        <template>
          <BaseTable
            :loading="loading"
            :items="items"
            :headers="headers"
            class="elevation-1"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.disabled`]="{ item }">
              <v-chip
                small
                :color="
                  item.disabled ? 'blue-grey lighten-3' : 'teal lighten-3'
                "
                dark
              >
                {{ item.disabled ? 'غیرفعال' : 'فعال' }}
              </v-chip>
            </template>
            <template v-slot:[`item.userPhone`]="{ item }">
              {{ item.userPhone || 'وارد نشده' }}
            </template>
            <template v-slot:[`item.isMainBranch`]="{ item }">
              <v-chip small color="teal lighten-3" dark>
                {{ item.isMainBranch ? 'اصلی' : 'فرعی' }}
              </v-chip>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip small :color="getMerchantStatusColor(item.status)" dark>
                <v-icon> mdi-circle-small </v-icon>
                {{ statusDisplayName(item.status) }}
              </v-chip>
            </template>
            <template v-slot:[`item.createdTimeUtc`]="{ item }">
              <span>
                {{ new Date(item.createdTimeUtc).toLocaleDateString('fa-IR') }}
              </span>
            </template>
            <template v-slot:[`item.logo`]="{ item }">
              <template v-if="item.logoFileUrl">
                <img
                  class="thumbnail"
                  :src="item.logoFileUrl.thumbnailFileUrl"
                  :alt="item.companyTitle"
                  max-height="60"
                  max-width="90"
                />
              </template>

              <span v-else>فاقد لوگو</span>
            </template>
            <template v-slot:[`item.unreadMessageCount`]="{ item }">
              <v-badge
                color="primary"
                :content="item.unreadMessageCount"
                inline
              ></v-badge>
            </template>
            <template v-slot:[`item.operation`]="{ item }">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item
                    link
                    color="primary"
                    @click="
                      $router.push({
                        path: `/merchant-companies/${item.merchantId}/information`,
                      })
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="blue" small>mdi-eye</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>مشاهده جزئیات</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    link
                    color="blue"
                    @click="openEditForm(item)"
                    v-if="
                      $store.getters.currentUserIsVisitor &&
                      (item.status == 'Draft' || item.status == 'Rejected')
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="blue" small>mdi-lead-pencil</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>ویرایش</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    @click="showSupplierPageInSite(item)"
                    color="blue"
                    v-if="item.status == 'Approved'"
                  >
                    <v-list-item-icon>
                      <v-icon color="blue" small>mdi-web</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >مشاهده کسب و کار در سایت</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-if="item.status == 'Draft' || item.status == 'Rejected'"
                    link
                    color="blue"
                    @click="sendRequestForConfirmation(item)"
                  >
                    <v-list-item-icon>
                      <v-icon color="blue" small>mdi-send</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        ارسال جهت تایید و انتشار</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    v-if="item.status !== 'Approved'"
                    link
                    color="red"
                    @click="deleteMerchantById(item.merchantId)"
                  >
                    <v-list-item-icon>
                      <v-icon color="red" small>mdi-close</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>حذف</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- ---------------------------- -->
                  <v-list-item
                    link
                    color="primary"
                    @click="openMerchantPermittedUsersDialog(item)"
                  >
                    <v-list-item-icon>
                      <v-icon color="primary" small> mdi-account-check </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>امکان دسترسی</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="openMerchantPermittedUsersListDialog(item)"
                    link
                    color="primary"
                  >
                    <v-list-item-icon>
                      <v-icon color="primary" small>
                        mdi-playlist-check
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> لیست دسترسی </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    @click="merchantEvents(item)"
                    link
                    color="primary"
                  >
                    <v-list-item-icon>
                      <v-icon color="primary" small>
                        mdi-calendar-range
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> سوابق تغییرات </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    @click="openCreatorReplacmentDialog(item)"
                    link
                    color="primary"
                  >
                    <v-list-item-icon>
                      <v-icon color="primary" small>
                        mdi-account-circle
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> تغییر کاربر ادمین </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </BaseTable>
          <div class="text-center mt-5">
            <v-row>
              <v-col cols="12" sm="4" md="2">
                <v-select
                  outlined
                  dense
                  v-model="itemsPerPage"
                  :items="[5, 10, 20]"
                  label="تعداد نمایش در صفحه"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="8" md="10">
                <v-pagination
                  circle
                  v-model="pageNumber"
                  :length="pageCount"
                  :total-visible="7"
                ></v-pagination>
              </v-col>
            </v-row>
          </div>
        </template>
      </BaseCard>
    </transition>
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="merchantEventsDialog"
      max-width="1200px"
    >
      <v-card>
        <v-card-title>
          <span>سوابق تغییرات </span>
          <v-spacer></v-spacer>
          <v-btn icon color="error">
            <v-icon @click="closeMerchantEventsDialog()">mdi mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <BusinessInformationEvents
          :merchantId="selectedMerchantForShowEvent"
        ></BusinessInformationEvents>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="creatorReplacmentDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title> تغییر کاربر ادمین </v-card-title>
        <v-card-text>
          <v-form ref="creatorReplacmentForm" v-model="creatorReplacmentValid">
            <v-row>
              <v-col cols="12">
                <label for="">
                  شماره همراه <span class="text-danger">*</span></label
                >
                <v-text-field
                  append-icon="mdi-numeric-0"
                  required
                  :rules="[
                    (v) =>
                      !!v ||
                      /^(\d{10,10})+$/.test(v) ||
                      'شماره همراه حتما باید عدد و 10 رقم باشد',
                  ]"
                  counter
                  maxlength="10"
                  v-model="creatorReplacment.newCreatorPhoneNumber"
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  solo
                  dense
                  @keypress="isNumber($event)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn
            color="red"
            small
            outlined
            @click="closeCreatorReplacmentDialog()"
            >بستن</v-btn
          >
          <v-btn color="primary" small outlined @click="saveCreatorReplacment()"
            >ذخیره</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="addMerchantPermittedUsersDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title class="headline">
          <v-col cols="12" class="d-flex justify-start">
            <span>امکان دسترسی کسب و کار به کاربر</span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="merchantPermittedUsersForm"
            v-model="merchantPermittedUsersValid"
          >
            <v-row> </v-row>
            <v-col cols="12" md="6">
              <label for=""> شماره همراه *</label>
              <v-text-field
                required
                :rules="[
                  (v) =>
                    !!v ||
                    /^(\d{11,11})+$/.test(v) ||
                    'شماره همراه حتما باید عدد و 11 رقم باشد',
                ]"
                counter
                maxlength="11"
                v-model="addMerchantPermittedUsers.userPhoneNumber"
                type="number"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                solo
                dense
                @keypress="isNumber($event)"
              ></v-text-field>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color=" primary darken-1"
            outlined
            @click="addUserToMerchantPermittedUsers()"
          >
            ثبت
          </v-btn>
          <v-btn
            color="red darken-1"
            outlined
            @click="closeMerchantPermittedUsersDialog()"
          >
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="merchantPermittedUsersListDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title class="headline">
          <v-col cols="12" class="d-flex justify-start">
            <span>لیست دسترسی کاربران به کسب و کار </span>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="merchantPermittedUsersListHeader"
            :items="merchantPermittedUsersList"
            class="elevation-1"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                color="danger"
                class="ma-1"
                @click="removeUserToMerchantPermittedUser(item)"
                outlined
                small
              >
                لغو دسترسی
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="closeMerchantPermittedUsersListDialog()"
          >
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import MerchantsSearch from './MerchantsSearch.vue';
const merchantCompanyRepository = () => RepoFactory.get('merchantCompany');
const settingRepository = () => RepoFactory.get('setting');
const merchantRepository = () => RepoFactory.get('merchant');
import Helper from '@/core/helpers';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import BusinessInformationEvents from '@/components/businessInformation/events/BusinessInformationEvents.vue';
export default {
  components: {
    BusinessInformationEvents,
    MerchantsSearch,
  },
  data() {
    return {
      searchParams: {
        name: null,
        status: null,
        // CreatedFromDate: null,
        // CretedToDate: null,
      },
      loading: false,
      items: [],
      itemsPerPage: 10,
      pageNumber: 1,
      pageCount: 0,
      headers: [
        { sortable: false, text: 'لوگو', value: 'logo' },
        { sortable: true, text: 'نام کسب و کار', value: 'name' },

        // {
        //   sortable: true,
        //   text: 'شعبه',
        //   value: 'isMainBranch',
        // },
        // { sortable: true, text: 'شماره موبایل', value: 'userPhone' },

        { sortable: true, text: 'مدت ثبت', value: 'daysFromCreation' },
        { sortable: true, text: 'تاریخ ثبت', value: 'createdTimeUtc' },
        // { sortable: false, text: '', value: 'disabled' },
        { sortable: true, text: 'وضعیت کسب و کار', value: 'status' },
        {
          sortable: true,
          text: 'پیام‌های خوانده نشده',
          value: 'unreadMessageCount',
        },
        { sortable: false, text: 'عملیات', value: 'operation' },
      ],

      detailDialog: false,
      selectedSupplierProductForShowDetail: null,
      merchantStatusList: [],
      filters: null,
      //////////////
      merchantPermittedUsers: null,
      addMerchantPermittedUsersDialog: false,
      addMerchantPermittedUsers: {
        userPhoneNumber: '',
      },
      merchantPermittedUsersValid: true,
      merchantPermittedUsersListDialog: false,
      merchantPermittedUsersList: [],
      merchantPermittedUsersListHeader: [
        {
          text: 'شماره تلفن ',
          align: 'start',
          sortable: true,
          value: 'phoneNumber',
        },
        {
          text: 'عملیات',
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ],
      saleSetting: null,
      saleSettingFormDialog: false,
      selectedMerchant: null,
      merchantEventsDialog: false,
      loadingMerchantEventsTable: true,
      selectedMerchantForShowEvent: null,
      creatorReplacmentDialog: false,
      creatorReplacment: {
        newCreatorPhoneNumber: '',
      },
      creatorReplacmentValid: true,
    };
  },
  computed: {
    ...mapGetters(['merchantBaseUrl', 'productBaseUrl']),
    baseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    registerMerchantUrl() {
      return location.origin + '/business-registration';
    },
    settingBaseUrl() {
      return this.$store.getters.settingBaseUrl;
    },
  },
  created() {
    this.getMerchantsList();
    this.getMerchantStatusList();
    this.checkCurrentUserIsVisitor();
  },

  watch: {
    pageNumber(after, before) {
      this.getMerchantsList(after, this.itemsPerPage, this.searchParams);
    },
    itemsPerPage(after, before) {
      this.getMerchantsList(this.pageNumber, after, this.searchParams);
    },
    // searchParams(after) {
    //   console.log("after is",after)
    //    this.getMerchantsList(this.pageNumber, this.itemsPerPage, after);
    // },
    // merchantId() {
    //   this.getMerchantsList(1, this.itemsPerPage);
    // },
  },
  methods: {
    search(params) {
      this.searchParams = params;
      console.log("this.searchParams", params)
      this.getMerchantsList(this.pageNumber, this.itemsPerPage, params);
    },
    openEditForm(item) {
      this.$router.push({
        //path: `/merchant-companies/${item.merchantId}/edit`,
        path: `/business-information/${item.merchantId}/edit`,
      });
    },
    showSupplierPageInSite(item) {
      let str = item.name.replace(/\s+/g, '-').toLowerCase();
      let pageUrl =
        this.$store.getters.taksaanUrl +
        '/supplier/' +
        item.merchantId +
        '/' +
        str +
        '?panel=supplier';
      window.open(pageUrl, '_blank');
    },
    closeCreatorReplacmentDialog() {
      this.creatorReplacmentDialog = false;
      this.creatorReplacment = {
        newCreatorPhoneNumber: '',
      };
    },
    isNumber(event) {
      let char = String.fromCharCode(event.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else event.preventDefault();
    },
    openMerchantPermittedUsersDialog(item) {
      this.addMerchantPermittedUsersDialog = true;
      this.merchantPermittedUsers = item;
    },
    closeMerchantPermittedUsersDialog() {
      this.addMerchantPermittedUsersDialog = false;
      this.merchantPermittedUsers = null;
      this.$refs.merchantPermittedUsersForm.reset();
    },
    removeUserToMerchantPermittedUser(item) {
      this.$dialog.warning({
        text: `آیا از لغو دسترسی کاربر با شماره تلفن <span class="red--text">${item.phoneNumber}</span> اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              let body = {
                userPhoneNumber: item.phoneNumber,
              };
              merchantRepository()
                .removeUserToMerchantPermittedUser(
                  this.merchantPermittedUsers.merchantId,
                  body,
                  this.baseUrl,
                  {}
                )
                .then((data) => {
                  this.getUserToMerchantPermittedUser();
                  this.$dialog.message.success('دسترسی با موفقیت لغو گردید', {
                    position: 'top-left',
                  });
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                });
            },
          },
        },
      });
    },
    openMerchantPermittedUsersListDialog(item) {
      this.merchantPermittedUsersListDialog = true;
      this.merchantPermittedUsers = item;

      this.getUserToMerchantPermittedUser();
    },
    getUserToMerchantPermittedUser() {
      this.merchantPermittedUsersList = [];
      merchantRepository()
        .getUserToMerchantPermittedUser(
          this.merchantPermittedUsers.merchantId,
          this.baseUrl,
          {}
        )
        .then((res) => {
          res.data.forEach((element) => {
            this.merchantPermittedUsersList.push({ phoneNumber: element });
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    closeMerchantPermittedUsersListDialog() {
      this.merchantPermittedUsersListDialog = false;
      this.merchantPermittedUsers = null;
      this.merchantPermittedUsersList = [];
    },
    addUserToMerchantPermittedUsers() {
      if (this.$refs.merchantPermittedUsersForm.validate()) {
        merchantRepository()
          .addUserToMerchantPermittedUser(
            this.merchantPermittedUsers.merchantId,
            this.addMerchantPermittedUsers,
            this.baseUrl,
            {}
          )
          .then((res) => {
            this.$dialog.message.success(
              'امکان دسترسی به کاربر با موفقیت ثبت گردید .',
              {
                position: 'top-left',
              }
            );
            this.closeMerchantPermittedUsersDialog();
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          });
      } else {
        this.$dialog.error({
          text: 'وارد کردن نام شرکت الزامی میباشد.',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    merchantEvents(item) {
      this.selectedMerchantForShowEvent = item.merchantId;
      this.merchantEventsDialog = true;
      this.loadingMerchantEventsTable = false;
    },
    closeMerchantEventsDialog() {
      this.merchantEventsDialog = false;
      this.selectedMerchantForShowEvent = null;
    },
    openCreatorReplacmentDialog(item) {
      this.creatorReplacmentDialog = true;
      this.merchantSelectedForCreatorReplacment = item;
    },
    saveCreatorReplacment() {
      if (this.$refs.creatorReplacmentForm.validate()) {
        merchantRepository()
          .postCreatorReplacment(this.creatorReplacment, this.baseUrl, {
            MerchantId: this.merchantSelectedForCreatorReplacment.merchantId,
          })
          .then((res) => {
            this.closeCreatorReplacmentDialog();
            this.getMerchants(this.pageNumber, this.itemsPerPage);
            this.$dialog.message.success('با موفقیت ثبت گردید', {
              position: 'top-left',
            });
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          });
      } else {
        this.$dialog.error({
          text: 'وارد کردن مقدار  الزامی میباشد.',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    //////////////////////
    getMerchantStatusColor(status) {
      if (status == 'Accepted') {
        return 'teal lighten-2';
      }
      if (status == 'Rejected') {
        return 'red lighten-2';
      }
      if (status == 'Draft') {
        return 'blue-grey lighten-3';
      }
      if (status == 'Approved') {
        return 'teal lighten-2';
      }
      if (status == 'InProgress') {
        return 'blue lighten-2';
      }
      return '';
    },

    deleteMerchantById(merchantId) {
      Swal.fire({
        html: `لطفا درنظر داشته باشید با حذف کسب و کار تمام اطلاعات از بین خواهد رفت !!`,
        icon: 'warning',
        confirmButtonText: ' حذف شود',
        showCancelButton: true,
        cancelButtonText: 'خیر',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show();
          merchantCompanyRepository()
            .deleteMerchantById(merchantId, this.merchantBaseUrl)
            .then(() => {
              const item = this.items.find((el) => el.merchantId == merchantId);
              this.items.splice(this.items.indexOf(item), 1);
              Swal.fire({
                icon: 'success',
                text: 'کسب و کار با موفقیت حذف شد',
                confirmButtonText: ' بستن',
              });
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        }
      });
    },
    sendRequestForConfirmation(item) {
      Swal.fire({
        html: `اطلاعات شما جهت تایید به پشتیبانی ارسال میشود`,
        icon: 'warning',
        confirmButtonText: ' بلی',
        showCancelButton: true,
        cancelButtonText: 'خیر',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show();
          merchantRepository()
            .merchantRequestConfirmation(item.merchantId, this.merchantBaseUrl)
            .then(() => {
              item.status = 'InProgress';
              Swal.fire({
                icon: 'success',
                title:
                  'ارسال درخواست با موفقیت انجام شد نتیجه به اطلاع شما خواهد رسید',
                confirmButtonText: ' بستن',
              });
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        }
      });
    },
    statusDisplayName(title) {
      const status = this.merchantStatusList.find((el) => el.title == title);
      if (status) {
        return status.displayName;
      }
      return '';
    },
    getMerchantStatusList() {
      this.$store
        .dispatch('getMerchantStatusList')
        .then((res) => {
          this.merchantStatusList = res;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },

    getMerchantsList(pageNumber = 1, itemsPerPage = 10, param = {}) {
      const loader = this.$loading.show();
      this.loading = true;
      this.pageNumber = pageNumber;
      this.itemsPerPage = itemsPerPage;
      let params = {
        PageNumber: pageNumber,
        ItemsPerPage: itemsPerPage,
        ...param,
      };
      merchantCompanyRepository()
        .getMerchantCompanies(this.merchantBaseUrl, params)
        .then((res) => {
          if (!res.data.list) res.data.list = [];
          this.pageCount = Math.ceil(res.data?.totalCount / itemsPerPage);
          this.items = res.data?.list;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    checkCurrentUserIsVisitor() {
      //----------------------
      settingRepository()
        .getSettings(
          this.settingBaseUrl,
          { clientId: 'TaksaanVisitorsInSupplier' },
          {}
        )
        .then((res) => {
          let visitorPhones = [];
          res.data.visitorsData.forEach((el) => {
            visitorPhones.push(el.PhoneNumber);
          });
          this.$store.commit('setVisitorsPhoneList', []);
          this.$store.commit('setVisitorsPhoneList', visitorPhones);
          // console.log("visitorPhones from store", this.$store.getters.visitorsPhoneList)
          let userPhone = this.$store.getters.userDetails.phone;

          let findedePhone = visitorPhones.find((f) => f == userPhone);
          //console.log("findedePhone is", findedePhone)
          //console.log("userPhone is",userPhone)
          if (findedePhone === userPhone) {
            //currentUserIsVisitor = true;

            this.$store.commit('setCurrentUserIsVisitor', true);
            // store.commit('setAuthorize', 'registration');
            //console.log("setCurrentUserIsVisitor for current user is ",this.$store.getters.currentUserIsVisitor)
          }
          //----------------------------
        })
        .catch((error) => {
          console.log('error On getting visitors phone', error);
        })
        .finally();

      //-----------------
    },
  },
};
</script>

<style scoped>
.thumbnail {
  width: 60px;
  border-radius: 5px;
  margin: 2px 0 !important;
}
</style>
